export const specialPriceList = [
  //   "VEH181757",
  //   "VEH183355",
  //   "VEH183356",
  //   "VEH183353",
  //   "VEH183359",
  //   "VEH183367",
  //   "VEH183358",
  //   "VEH183360",
  //   "VEH183361",
  //   "VEH183362",
  //   "VEH183363",
  //   "VEH183364",
  //   "VEH183365",
  //   "VEH183366",
  //   "VEH183357",
];
